import { Button, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useState } from "react";
import { renderClose } from "../../common/dialog";
import { createEntityStore } from "../../common/entityStore";
import { propBoolField, propNumberField, propTextField } from "../../common/entityStoreForm";
import { propInt, propLengthMax, propRequired, propValidValue } from "../../common/entityStoreValidators";
import { TmCallResultDto, TmCallResultEditDto } from "./types";
import { EntityStoreSaveButton } from "../../common/SaveButton";
import { UseListStore } from "../../common/listStore";
import { max } from "lodash";

export function TmCallResultDialog(props: {
    close: () => void;
    tmCallResult: TmCallResultDto | null;
    onChange(): void;
    useListStore: UseListStore<TmCallResultDto>;
}) {
    const [useStore] = useState(() => createEntityStore<TmCallResultEditDto>({
        data: props.tmCallResult ?? { id: null, code: "", name: "", position: (max(props.useListStore.getState().items.map(p => p.position)) ?? 0) + 1, isActive: true },
        path: "settings/tmCallResults",
        fetchOnInit: false,
        id: props.tmCallResult == null ? null : props.tmCallResult.id,
        onSaved() {
            props.onChange();
            props.close();
        },
        propValidators: [
            propRequired("code"),
            propLengthMax("code", 10),
            propRequired("name"),
            propLengthMax("name", 200),
            propValidValue("position", "positionFormatted"),
            propRequired("position"),
            propInt("position"),
        ]
    }));

    const serverData = useStore(p => p.serverData);
    return <>
        <DialogTitle>{serverData.id == null ? "New TM call result" : `Edit TM call result - ${serverData.code}`}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <Grid container columnSpacing={2} alignItems="stretch">
                <Grid item xs={4}>{propTextField(useStore)("code", "Code",)}</Grid>
                <Grid item xs={4}>{propNumberField(useStore)("position", "positionFormatted", "Position")}</Grid>
                <Grid item xs={4}>{propBoolField(useStore)("isActive", "Active?")}</Grid>
                <Grid item xs={12}>{propTextField(useStore)("name", "Name",)}</Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <EntityStoreSaveButton useStore={useStore} />
            <Button onClick={props.close} color="negative" variant="outlined">Close</Button>
        </DialogActions>
    </>;
};